import PatientShuttle from "../../tenants/mayo/patientFacing/mayo1/PatientShuttle";

export default function DemoPatientShuttle() {
  return <PatientShuttle/>;
}